import "./index.scss";

const Loading = () => {
    return (
        <div className="loading-container">
            <span className="loading" />
        </div>
    );
};
export default Loading;
